!(function($){
	// Init collecction slider/product slider autoplay
	setTimeout(function(){
		// $('.product-grid--root').trigger('owl.play', 3000);
		$('.product-grid--root').each(function(){
			var ifAutoplay = $(this).attr('data-autoplay');
			var autoplaySpeed = parseInt($(this).attr('data-autoplay-speed'));
			if (ifAutoplay == 'true') {
				$(this).trigger('owl.play', autoplaySpeed);
			}
		});
	}, 0);
})(jQuery);


$(document).ready(function() {

	// $('.featured-blocks').owlCarousel2({
	//     margin:0,
	//     loop:true,
	//     autoWidth:true,
	//  	center:true,
	//     items:15
	// });
	
	// $('.product-slider2 .product-grid--root').each(function() {
	// 	$(this).owlCarousel2({
	// 		items: 4,
	// 		loop:true,
	//    		autoplay: $(this).attr('data-autoplay'),
	//    		autoplayTimeout: $(this).attr('data-autoplay-speed'),
	// 	   	responsive:{
	// 	        0:{
	// 	            items:2
	// 	        },
	// 	        480:{
	// 	            items:3
	// 	        },
	// 	        991:{
	// 	            items:4
	// 	        }
	// 	    }
	// 	});  
	// });


	$('.jdgm-carousel-item__product-image').attr('width', 150).attr('height', 150);


	$('.product-section-new-main .product-block').each(function() {
		var sectionBadge = $(this).attr('data-badge');
		var sectionCTA = $(this).attr('data-cta');
		if (sectionBadge != '') {
			$(this).find('.product--price-wrapper .discount-percentage-block').remove();
			$(this).find('.product--price-wrapper').append('<h4 class="discount-percentage-block">'+sectionBadge+'</h4>');  
		}	
		if (sectionCTA != '') {
			$(this).find('.shop-button-box .button').text(sectionCTA);  
		}	
	});	

	$('.product-section-new-main .product--details-inner').matchHeight();

	

});
var resizeTimerH;

$(window).on('resize', function(e) {
  clearTimeout(resizeTimerH);
  resizeTimerH = setTimeout(function() {
  	$('.product-section-new-main .product--details-inner').matchHeight();
  }, 250);
});